import { getGoogleCalendarUrl, getOutlookCalendarUrl } from '../../lib/calendar';
import type { CalendarEvent } from '../../types';

type Props = CalendarEvent;

export function CalendarButtons(props: Props) {
  const googleUrl = getGoogleCalendarUrl(props);
  const outlookUrl = getOutlookCalendarUrl(props);

  return (
    <div className="hit-card mb-4">
      <h3 className="text-sm font-extrabold uppercase tracking-widest text-hit-gray-dark mb-4">
        Agrega a tu Calendario:
      </h3>
      <div className="flex flex-col gap-2">
        <a
          href={googleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 justify-center border border-hit-gray-light rounded-lg py-3 px-4 text-sm font-semibold text-hit-black hover:bg-hit-gray-light/30 transition-colors"
        >
          <span>📥</span> Google Calendar
        </a>

        <a
          href={outlookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 justify-center border border-hit-gray-light rounded-lg py-3 px-4 text-sm font-semibold text-hit-black hover:bg-hit-gray-light/30 transition-colors"
        >
          <span>📥</span> Outlook
        </a>
      </div>
    </div>
  );
}
